<script setup lang="ts">
import IdentifierLabel from '@/components/IdentifierLabel/IdentifierLabel.vue';
import { getRouteMetaMerged } from '@/router/utils';
import { t } from 'i18next';
import { useRoute } from 'vue-router';

interface BasePagetitleProps {
  title?: string | null;
  titleId?: string | null;
  subtitle?: string;
  fallbackTitle?: string;
}

const props = withDefaults(defineProps<BasePagetitleProps>(), {
  title: undefined,
  titleId: undefined,
  subtitle: undefined,
  fallbackTitle: () => t('Untitled'),
});

const route = useRoute();
const icon = getRouteMetaMerged(route).icon;
</script>

<template>
  <div class="pageTitle text-primary-darken-2">
    <v-icon v-if="icon" class="mr-4" :size="56">{{ icon }}</v-icon>
    <div class="pageDetails">
      <p class="text-caption text-primary-lighten-1 font-weight-medium" aria-label="page-sub-title">
        {{ subtitle }}
      </p>
      <h3 class="mb-0">
        <IdentifierLabel
          :label="props.title || props.fallbackTitle"
          :identifier="props.titleId"
          :truncate="true"
          aria-label="page-title"
        />
      </h3>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/styles/variables';

.pageTitle {
  display: flex;
  align-items: center;
  height: variables.$titleHeaderHeight;
  margin-right: 32px;
  .pageDetails {
    display: flex;
    flex-flow: column;
    gap: 2px;
    flex: 1;
    min-width: 0;
  }
}
</style>
